import { applyMiddleware, combineReducers, createStore } from "redux";

import {
  Reducer,
  ReducerPromoProductsData,
  ReducerNewProductsData,
  ReducerDepData,
  ReducerAllProducts,
  ReducerVegProducts,
  ReducerChangeName,
  LoginData,
  ReducerBrandProducts,
  ReducerBrandsData,
} from "./Reducer";
import thunk from "redux-thunk";
// import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

const rootReducer = combineReducers({
  Reducer,
  ReducerPromoProductsData,
  ReducerNewProductsData,
  ReducerNewProductsData,
  ReducerDepData,
  ReducerBrandsData,
  ReducerAllProducts,
  ReducerVegProducts,
  ReducerChangeName,
  LoginData,
  ReducerBrandProducts,
});
//  const persistConfig = {
//     key: 'root',
//     storage, // You can use sessionStorage instead of localStorage if needed
//   };

//  const persistReducerVariable=persistReducer()
//  const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  // persistedReducer
  rootReducer,
  applyMiddleware(thunk)
);
// const persistor = persistStore(store);

export {
  store,
  //  persistor
};
